module.exports = __webpack_public_path__ + "static/media/alethea.3d58c9f7.png";